import {FrontendRequest} from "services-comun/modules/net/request-frontend";
import {logRejection} from "services-comun/modules/decorators/metodo";
import dominio from "../../../portal/ed";
import {IVideoResumen} from "../interface";
import {stringify} from "qs";

export class VideoWebFrontendRequest extends FrontendRequest {
    /* STATIC */
    private static SERVICIO: string = dominio.get(dominio.SERVICES);

    @logRejection(true)
    public static async getVideos(posicion: number): Promise<IVideoResumen[]> {
        const params = stringify({
            posicion,
        });
        return await this.get<IVideoResumen[]>(`${this.SERVICIO}/web/videos/listado/?${params}`).then(resp => resp.data);
    }

    /* INSTANCE */
}
